// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__jb1_b","col":"styles_col__1k-VT"};